import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectComponent } from './multiselect.component';
/**
 * NgModule definition for the MultiSelect component.
 */
export class MultiSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        MultiSelectComponent
    ],
    exports: [
        MultiSelectComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MultiSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
MultiSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MultiSelectModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
